import { Component, OnInit, Renderer2, ViewChild, ElementRef, TemplateRef, OnDestroy, AfterViewInit, signal } from '@angular/core';
import { DeviceService } from '../services/device.service';
import { GroupService } from '../services/group.service';
import { ControlService } from '../services/control.service';
import { SettingsService } from '../services/settings.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { TrackerService } from '../services/tracker.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StackService } from '../services/stack-service.service';
import { CommonService } from '../services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceControlComponent } from './device-control/device-control.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MediaComponent } from './media/media.component';
import { AutomationComponent } from './automation/automation.component';
import { AiAutomationComponent } from './ai-automation/ai-automation.component';
import { LogsComponent } from './logs/logs.component';
import { ExplorerComponent } from './explorer/explorer.component';
import { InfoComponent } from './info/info.component';
import { DeviceStatusPipe } from '../device-status-pipe';
import { VideoService } from '../services/video.service';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, DeviceControlComponent, DashboardComponent, MediaComponent, AutomationComponent, AiAutomationComponent, LogsComponent, ExplorerComponent, InfoComponent, DeviceStatusPipe]
})
export class ControlComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly translations: Record<string, string> = {
    ungroup_request: 'You (or someone else) kicked the device.', //working
    owner_change: 'Someone stole your device.',
    automatic_timeout: 'Device was kicked by automatic timeout.',
    device_absent: 'Device is not present anymore for some reason.',
    status_change: 'Device is present but offline.',
    undefined: 'Device not reachable.'
  };
  // @Input() isAppInspector;
  @ViewChild('mobileAndNavbar', { static: true }) mobileAndNavbarRef: ElementRef;
  @ViewChild('DashboardAndLogs', { static: true }) dashboardAndLogsRef: ElementRef;
  private isResizing = false;
  private startX: number;
  private startLeftWidth: number;
  private startRightWidth: number;
  private totalWidth: number;
  isIos = signal<boolean>(false);
  isiPad: boolean = false;
  Androidloader: boolean = false;
  Iosloader: boolean = false;
  checkpoint: any;
  isLogsVisible = true;
  logsheight: number
  oldvalue: any
  fatelMessage: boolean = false
  deviceList: any;
  screenshots: any[] = [];
  screenShotSize = 400;
  data: any
  newvalue: any
  sharedTabs: any[] = [];
  device: any = null;
  control: ControlService;
  Url: string
  serial: any;
  //tracker: TrackerService;
  showFileExplorer: boolean = true;
  renderChildComponent: boolean = false;
  //tulya
  modalRef!: MatDialogRef<any>;
  trackerSubscription: Subscription;
  checkpointIndex: number = 1;

  @ViewChild('deviceAlertTemplate') alertTemplate: TemplateRef<any>;

  @ViewChild('dashboard', { static: true }) dashboard: ElementRef;
  @ViewChild('logs', { static: true }) logs: ElementRef;
  callonce: boolean = true;
  callonce2: boolean = true;
  tracker: TrackerService
  currentUser: any;


  constructor(
    private deviceService: DeviceService,
    private groupService: GroupService,
    private controlService: ControlService,
    private settingsService: SettingsService,
    private dialog: MatDialog,
    private stackService: StackService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private commonService: CommonService,
    private videoService: VideoService
  ) {

  }

  ngAfterViewInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);
    //to check that the provided device is iPad or not
    this.isiPad = /^iPad(_.*)?$/.test(this.device?.model);
  }

  ngOnDestroy(): void {
    this.Url = null
    if (this.trackerSubscription) {
      this.trackerSubscription.unsubscribe(); // Unsubscribe to prevent memory leaks
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      // Optional: Show a success message or tooltip
    });
  }

  ngOnInit(): void {
    window.onbeforeunload = null;

    this.Url = this.router.url

    this.route.params.subscribe((params: Params) => {
      this.serial = params['id'];
    });
    this.getDevice(this.serial);
    this.deviceList = this.stackService.getStack();
    this.tracker = this.deviceService.trackAll();
    // console.log(this.tracker)
    this.tracker.trackerEventEmitter.subscribe((data: any) => {
      console.log("data:\n", data);
      console.log("data.data.using:", data.data.using,
        "\ndata.data.state", data.data.state,
        "\ndata.data.status", data.data.status,
        "\ndata.data.present", data.data.present,
        "\ndata.data.enhancedStateAction", data.data.enhancedStateAction,
        "\ndata.data.owner", data.data.owner,
        '\ntimestamp:', new Date().toTimeString().split(' ')[0]);

      this.data = data;
      if (data.data.serial == this.serial) {
        // setTimeout(() => {
        //   if (data.data.ios) {
        //     this.isIos.set(data.data.ios);
        //   }
        //   // console.log('inside serial check block\ndata.data.serial:',data.data.serial,'\nthis.serial',this.serial);

        //   // //check for device state change
        //   // if (!data.data.using) {
        //   //   //check that if we are inside control
        //   //   if (this.Url.includes('/control')) {
        //   //     //check if user is not already shown an alert
        //   //     if (this.callonce2) {
        //   //       this.callonce2 = false;
        //   //       if (!this.modalRef) {
        //   //         this.modalRef = this.dialog.open(this.alertTemplate,{
        //   //           disableClose: true, 
        //   //           disableClose: true,    
        //   //         })
        //   //       }
        //   //     }
        //   //   }
        //   // }

        //   //new
        //   // setTimeout(() => {
        //   //   if (data.data.state == 'available') {
        //   //     // If the device is available then reload else navigate to devices page
        //   //     this.ok();
        //   //   }
        //   // }, 5000)
        //   //check for device state change
        //   // <------------ commented to check if this is creating issue for "Unknown reason"------------->
        //   // if (data.data.state != 'using') {
        //   //   //check that if we are inside control
        //   //   if (this.Url?.includes('/control')) {
        //   //     //check if user is not already shown an alert
        //   //     if (this.callonce2) {
        //   //       this.callonce2 = false;
        //   //       if (!this.modalRef) {
        //   //         this.modalRef = this.dialog.open(this.alertTemplate, {
        //   //           disableClose: true,
        //   //           disableClose: true,
        //   //         })
        //   //       }
        //   //     }
        //   //   }
        //   // }
        //   // <------------ commented to check if this is creating issue for "Unknown reason"------------->
        //   if (!data.data.using) {
        //     if (this.Url.includes('/control')) {
        //       // let deviceUser;
        //       // this.deviceService.checkDeviceStatus(this.serial).subscribe((res: any) => {
        //       //   deviceUser = res.description?.email;
        //       // });
        //       // && deviceUser != this.currentUser?.email
        //       if (this.callonce) {
        //         this.callonce = false;
        //         if (!this.modalRef) {
        //           this.modalRef = this.dialog.open(this.alertTemplate)
        //           this.updateDisconnectionTimestamp();
        //           if (this.videoService.isRecording) {
        //             this.videoService.updateBoolean(false); // triggers stopRecording() in device-screen
        //           }
        //         }
        //       }
        //     }
        //   }
        // }, 10000)
        //new
        // Capture URL snapshot before async delay
        const currentUrl = this.Url ?? '';

        setTimeout(() => {

          // ── iOS flag (unchanged) ──────────────────────────────────────
          if (data.data.ios) {
            this.isIos.set(data.data.ios);
          }

          //status_change handled separately
          if (data.data?.likelyLeaveReason == "device_absent" && currentUrl.includes('/control') && this.callonce) {
            this.callonce = false;
            this._openDisconnectionModal('Device is present but offline.');
            return;
          }

          // ── No disconnection scenario, reset state ────────────────────
          if (data.data.using) {
            if (this.modalRef) {
              this.modalRef.close();
              this.modalRef = null;
            }
            this.callonce = true;
            return;
          }

          // ── From here: device.using is false ─────────────────────────
          if (!currentUrl.includes('/control') || !this.callonce) return;

          const reason = data.data.likelyLeaveReason as string;

          // No reason at all = first-time device take edge case, ignore
          if (!reason) return;

          // owner_change & ungroup_request: verify via API since owner changes
          const ownerChangedReasons = ['ungroup_request', 'owner_change'];

          if (ownerChangedReasons.includes(reason)) {
            this.deviceService.checkDeviceStatus(this.serial).subscribe((res: any) => {
              const currentOwner: string | null = res.description?.email ?? null;
              const iLostOwnership = currentOwner !== this.currentUser?.email;

              if (iLostOwnership) {
                this.callonce = false;
                this._openDisconnectionModal(reason);
              }
              // else: garbage value, suppress
            });
            return;
          }

          // automatic_timeout, device_absent, status_change, undefined:
          // owner doesn't change — double-check API to filter garbage values
          this.deviceService.checkDeviceStatus(this.serial).subscribe((firstRes: any) => {
            const stillOwned = firstRes.description?.email === this.currentUser?.email;

            if (!stillOwned) {
              // Ownership already gone on first check — real disconnection
              this.callonce = false;
              this._openDisconnectionModal(reason);
              return;
            }

            // Still owned on first check — do one final re-check to confirm not garbage
            this.deviceService.checkDeviceStatus(this.serial).subscribe((freshRes: any) => {
              const stillOwnedAfterRecheck = freshRes.description?.email === this.currentUser?.email;

              if (!stillOwnedAfterRecheck) {
                this.callonce = false;
                this._openDisconnectionModal(reason);
              }
              // else: confirmed garbage value, suppress silently
            });
          });

        }, 2000);
        //new

      }
    });


    // for resize using drag
    // this.tracker.trackerEventEmitter.subscribe((data: any) => {
    //   this.logTrackerData(data);
    //   this.data = data;

    //   if (this.shouldProcessDeviceData(data)) {
    //     setTimeout(() => this.handleDeviceStateChange(data), 5000);
    //   }
    // });

    this.renderer.listen('document', 'mousemove', (event) => {
      if (this.isResizing) {
        this.resize(event);
      }
    });

    this.renderer.listen('document', 'mouseup', () => {
      this.isResizing = false;
    });
  }

  private _openDisconnectionModal(reason: keyof typeof this.translations): void {
    if (!this.modalRef) {
      this.modalRef = this.dialog.open(this.alertTemplate, {
        data: {
          reason,
          message: this.translations[reason] ?? this.translations['undefined']
        }
      });
      this.updateDisconnectionTimestamp();
      if (this.videoService.isRecording) {
        this.videoService.updateBoolean(false);
      }
    }
  }

  async getDevice(serial: string): Promise<any> {
    try {
      const device: any = await firstValueFrom(this.deviceService.get(serial));

      // if (device.platform == 'Android' && !this.deviceList.includes(serial)) {
      //   this.Androidloader = true;
      //   const intervalTime = 2000;//2 seconds
      //   setInterval(() => {
      //     if (this.checkpointIndex <= 5)
      //       this.checkpointIndex++;
      //   }, intervalTime);
      //   setTimeout(() => {
      //     this.Androidloader = false;
      //   }, 10200)
      // }
      // if (device.platform == 'iOS' && !this.deviceList.includes(serial)) {
      //   this.Iosloader = true;
      //   const intervalTime = 2000;//2 seconds
      //   setInterval(() => {
      //     if (this.checkpointIndex <= 5)
      //       this.checkpointIndex++;
      //   }, intervalTime);
      //   setTimeout(() => {
      //     this.Iosloader = false;
      //   }, 10200)
      // }
      //device control navigation from here
      let stack = this.stackService.getStack();
      if (stack.includes(device.serial)) {
        this.stackService.delete(device.serial);
        this.stackService.push(device.serial);
      } else {
        this.stackService.push(device.serial);
      }
      const invitedDevice = this.groupService.invite(device);
      this.device = device;
      this.device.using = true;
      this.device.state = "using";
      this.control = this.controlService.create(device, device.channel);
      // this.takeScreenShot();



      // $rootScope.pageTitle = device.name
      this.settingsService.set('lastUsedDevice', serial);

      if (this.device.platform === 'Android') {
        this.showFileExplorer = true;
      } else {
        this.showFileExplorer = false;
      }

      //  $scope.topTabs = [
      //   {
      //     title: gettext('Dashboard'),
      //     icon: 'fa fa-dashboard fa-fw color-pink',
      //     templateUrl: 'control-panes/dashboard/dashboard.pug',
      //     filters: ['native', 'web']

      //   }
      // ].concat(angular.copy(sharedTabs))

      // $scope.belowTabs = [
      //   {
      //     title: gettext('Logs'),
      //     icon: 'fa fa-list-alt color-red',
      //     templateUrl: 'control-panes/logs/logs.pug',
      //     filters: ['native', 'web']
      //   }
      // ]

      this.renderChildComponent = true;
      // this.takeScreenShot();
      return device

    } catch (error) {
      // setTimeout(() => {
      //   // this.router.navigate(['/devices']);
      // });
    }





  }
  // resizeImageOfIos({ max = 100, step = 1 }) {
  //   // You can implement your resizing logic here
  //   console.log('Resizing image for iOS screenshot preview...');
  // }

  // takeScreenShot() {
  //   if (!this.device || !this.control) return;

  //   const serial = this.device.serial;

  //   const saveToSession = (image: string) => {
  //     sessionStorage.setItem(`deviceScreenshot-${serial}`, image);
  //   };

  //   setTimeout(() => {
  //     if (this.device.ios) {
  //       this.control.screenshotIos().then((result) => {
  //         this.control.screenshots.unshift(result);
  //         result.body.href = result.body.href.replace('/s/image/', '/s/blob/')
  //         let fullImageUrl = window.location.protocol + '//' + window.location.href.split('/')[2] + result.body.href;
  //         saveToSession(fullImageUrl);
  //         setTimeout(() => {
  //           this.resizeImageOfIos?.({ max: 100, step: 1 });
  //         }, 0);
  //       });
  //     } else {
  //       this.control.screenshot().then((result) => {
  //         this.control.screenshots.unshift(result);
  //         result.body.href = result.body.href.replace('/s/image/', '/s/blob/')
  //         let fullImageUrl = window.location.protocol + '//' + window.location.href.split('/')[2] + result.body.href;
  //         saveToSession(fullImageUrl);
  //         setTimeout(() => {
  //           this.resizeImageOfIos?.({ max: 100, step: 1 });
  //         }, 0);
  //       });
  //     }

  //     this.screenshots = this.control.screenshots;
  //   }, 5000);
  // }


  // Extract timestamp update logic
  private updateDisconnectionTimestamp(): void {
    const timestamp = this.formatDisconnectionTimestamp();

    this.deviceService.putDisconnectionTimestamp(this.serial, timestamp)
      .subscribe({
        next: (res) => {
          console.log("Disconnection timestamp and reason updated successfully.");
        },
        error: (err) => {
          console.error("Error updating disconnection timestamp and reason:", err);
        }
      });
  }

  private formatDisconnectionTimestamp(): any {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return {
      serial: this.device.serial,
      date: `${year}-${month}-${day}`,
      time: `${hours}:${minutes}:${seconds}`,
      reason: this.device.likelyLeaveReason || 'unknown'
    };
  }

  private changeListener(event: any): void {





    //  this.device.airplaneMode=event.data.airplaneMode


    // const device = this.get(event.data);

  }
  //   $scope.$watch('device.state', function(newValue, oldValue) {
  //     if (newValue !== oldValue) {
  // /*************** fix bug: it seems automation state was forgotten ? *************/
  //       if (oldValue === 'using' ) {
  // /******************************************************************************/
  //         FatalMessageService.open($scope.device, false)
  //       }
  //     }
  //   }, true)

  key(key: any) {
    if (this.device.ios) {
      this.control.keyPress(key)
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
  }

  second() {
    this.modalRef?.close();
    this.commonService.setActiveTab('/devices');
    this.router.navigate(['/devices'])
  }

  cancel() {
    this.modalRef?.close();
    this.ok()
  }

  ok() {
    console.log(this.device.enhancedStatePassive, "this.device.enhancedStatePassive");

    if (this.device.enhancedStatePassive == 'Available') {
      // this.router.navigate(['/control',this.serial]);
      location.reload()
    } else {
      this.modalRef?.close();
      this.commonService.setActiveTab('/devices');
      this.router.navigate(['/devices'])
    }
  }

  toggleLogs() {

    this.isLogsVisible = !this.isLogsVisible;
    document.getElementById('Logs').style.display = this.isLogsVisible ? 'block' : 'none';
    if (document.getElementById('Logs').style.display == 'block') {
      this.renderer.setStyle(this.dashboard.nativeElement, 'height', '59.5%');
      this.renderer.setStyle(this.logs.nativeElement, 'z-index', '100');
      this.renderer.setStyle(this.logs.nativeElement, 'height', '140em');
    }
    else
      this.renderer.setStyle(this.dashboard.nativeElement, 'height', '100%');
  }

  resizingStart(event: MouseEvent) {
    this.isResizing = true;
    this.startX = event.clientX;

    // Get the current widths as percentages
    const leftElement = this.mobileAndNavbarRef.nativeElement;
    const rightElement = this.dashboardAndLogsRef.nativeElement;

    this.startLeftWidth = leftElement.offsetWidth;
    this.startRightWidth = rightElement.offsetWidth;
    this.totalWidth = this.startLeftWidth + this.startRightWidth;

    // Prevent text selection during resize
    event.preventDefault();
  }

  private resize(event: MouseEvent) {
    if (!this.isResizing) return;

    const leftElement = this.mobileAndNavbarRef.nativeElement;
    const rightElement = this.dashboardAndLogsRef.nativeElement;

    // Calculate the new width based on mouse movement
    const moveX = event.clientX - this.startX;

    // Calculate new widths keeping the total constant
    let newLeftWidth = this.startLeftWidth + moveX;
    let newRightWidth = this.totalWidth - newLeftWidth;

    // Set minimum width constraints (e.g., 30% of total width)
    const minWidth = this.totalWidth * 0.3;

    if (newLeftWidth < minWidth) {
      newLeftWidth = minWidth;
      newRightWidth = this.totalWidth - minWidth;
    } else if (newRightWidth < minWidth) {
      newRightWidth = minWidth;
      newLeftWidth = this.totalWidth - minWidth;
    }

    // Calculate the new percentage widths
    const leftPercent = (newLeftWidth / this.totalWidth) * 100;
    const rightPercent = (newRightWidth / this.totalWidth) * 100;

    // Apply the new widths
    this.renderer.setStyle(leftElement, 'width', `${leftPercent}%`);
    this.renderer.setStyle(rightElement, 'width', `${rightPercent}%`);

    // Update the Bootstrap classes to match the new widths
    this.updateBootstrapClasses(leftElement, rightElement, leftPercent, rightPercent);
  }

  private updateBootstrapClasses(leftElement: HTMLElement, rightElement: HTMLElement, leftPercent: number, rightPercent: number) {
    // Remove existing column classes
    const colClasses = Array.from(leftElement.classList)
      .filter(cls => cls.startsWith('col-') || cls.startsWith('col-md-'));
    colClasses.forEach(cls => this.renderer.removeClass(leftElement, cls));

    const colClassesRight = Array.from(rightElement.classList)
      .filter(cls => cls.startsWith('col-') || cls.startsWith('col-md-'));
    colClassesRight.forEach(cls => this.renderer.removeClass(rightElement, cls));

    // Calculate the closest col-md value (out of 12)
    const leftColValue = Math.round((leftPercent / 100) * 12);
    const rightColValue = 12 - leftColValue;

    // Add the new classes
    this.renderer.addClass(leftElement, `col-${leftColValue}`);
    this.renderer.addClass(leftElement, `col-md-${leftColValue}`);
    this.renderer.addClass(rightElement, `col-${rightColValue}`);
    this.renderer.addClass(rightElement, `col-md-${rightColValue}`);
  }
}
